import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import { LumberListPrototype, LumberSet } from '@paragon/contract-library';

import { RootState } from '../store';

export const getLumberListPrototypes = createSelector(
  (state: RootState) => state.materialSetPrototype,
  (materialSetPrototype) =>
    materialSetPrototype.status === 'loaded' ? Object.values(materialSetPrototype.lumberListPrototypes) : 'loading',
);

export function useLumberListPrototype(lumberListGuid: string | undefined): LumberListPrototype | 'loading' | null {
  const materialSetPrototype = useSelector((state: RootState) => state.materialSetPrototype);
  if (materialSetPrototype.status !== 'loaded') return 'loading';

  return lumberListGuid ? (materialSetPrototype.lumberListPrototypes[lumberListGuid] ?? null) : null;
}

export function useLumberListPrototypeAndSet(
  lumberListGuid: string | undefined,
  lumberSetGuid: string | undefined,
): [LumberListPrototype, LumberSet] | 'loading' | null {
  const lumberList = useLumberListPrototype(lumberListGuid);
  if (lumberList === 'loading') return 'loading';

  const lumberSet = lumberList?.lumberSets.find((set) => set.guid === lumberSetGuid);
  if (!lumberList || !lumberSet) return null;

  return [lumberList, lumberSet];
}
